<template>
  <div class="boxs-page">
    <PageHeader
        :title="t('boxsPage.title')"
        :subtitle="t('boxsPage.subtitle')"
        :breadcrumbItems="[{ text: t('common.home'), path: '/' }]"
        :currentText="t('boxsPage.title')"
    />

    <!-- 降级数据提示 -->
    <el-alert
        v-if="isFallback"
        :title="errorMessage"
        type="info"
        :closable="false"
        center
        show-icon
        style="margin-bottom: 20px;"
    />

    <!-- 业务领域横幅 -->
    <div class="boxs-banner" :style="{ backgroundImage: `url(${require('@/assets/images/banner/banner1.jpg')})` }">
      <div class="overlay"></div>
      <div class="banner-content">
        <h2>{{ t('boxsPage.banner.title') }}</h2>
        <p>{{ t('boxsPage.banner.desc') }}</p>

        <!-- 搜索框 -->
        <div class="search-container">
          <el-popover
              placement="bottom"
              :title="t('boxsPage.searchResultsTitle')"
              width="100%"
              :visible="visible"
              popper-class="search-popover"
          >
            <template #reference>
              <el-input
                  v-model="searchText"
                  class="search-input"
                  :placeholder="t('boxsPage.searchPlaceholder')"
                  :prefix-icon="Search"
                  clearable
                  @input="visible = true"
              />
            </template>

            <div class="search-results">
              <div v-if="searchnewslist.length">
                <div
                    v-for="data in searchnewslist"
                    :key="data._id"
                    class="search-item"
                    @click="handleChangepage(data._id)"
                >
                  <div class="item-title">{{ data.title }}</div>
                  <div class="item-meta">{{ whichTime(data.editTime) }}</div>
                </div>
              </div>
              <div v-else>
                <el-empty :description="t('boxsPage.noRelatedBusiness')" :image-size="80" />
              </div>
            </div>
          </el-popover>
        </div>
      </div>
    </div>

    <div class="page-container">
      <!-- 热门业务 -->
      <section class="featured-section">
        <div class="section-header">
          <h2 class="section-title">{{ t('boxsPage.featuredSection.title') }}</h2>
          <p class="section-desc">{{ t('boxsPage.featuredSection.desc') }}</p>
        </div>

        <div
            class="marquee-container"
            @mouseenter="pauseMarquee"
            @mouseleave="resumeMarquee"
        >
          <div
              class="marquee-content"
              :style="{ animationPlayState: isPaused ? 'paused' : 'running' }"
          >
            <div
                class="featured-card"
                v-for="(item, index) in [...filteredTopNewsList, ...filteredTopNewsList]"
                :key="index + '-' + item._id"
                @click="handleChangepage(item._id)"
            >
              <div
                  class="card-image"
                  :style="{ backgroundImage: `url(${item.cover ? 'https://www.hexiangtaitech.com:3001' + item.cover : require('@/assets/images/product/麻辣口水鸡.jpg')})` }"
              >
                <div class="card-category">{{ getCategoryName(item.category) }}</div>
              </div>
              <div class="card-content">
                <h3 class="card-title">{{ item.title }}</h3>
                <div class="card-meta">
                  <time class="time">
                    <i class="el-icon-time"></i> {{ whichTime(item.editTime) }}
                  </time>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 业务分类（原样保持） -->
      <section class="categories-section" ref="categoriesSection">
        <div class="section-header">
          <h2 class="section-title">{{ t('boxsPage.categoriesSection.title') }}</h2>
          <p class="section-desc">{{ t('boxsPage.categoriesSection.desc') }}</p>
        </div>

        <el-tabs v-model="whichTab" class="category-tabs">
          <el-tab-pane
              v-for="item in tablist"
              :key="item.name"
              :label="t(`boxsPage.categoryTabs.${item.name}`)"
              :name="item.name"
          >
            <el-row :gutter="30">
              <!-- 左侧内容列表 -->
              <el-col :xs="24" :md="18" class="category-list">
                <div
                    v-for="data in filteredTabnews[item.name]"
                    :key="data._id"
                    class="category-item"
                    @click="handleChangepage(data._id)"
                >
                  <div
                      class="item-image"
                      :style="{ backgroundImage: `url(${data.cover ? 'https://www.hexiangtaitech.com:3001' + data.cover : require('@/assets/images/product/红烧排骨.jpg')})` }"
                  ></div>
                  <div class="item-content">
                    <h3 class="item-title">{{ data.title }}</h3>
                    <p class="item-summary">{{ getSummary(data.content) }}</p>
                    <div class="item-meta">
                      <time class="time">
                        <i class="el-icon-time"></i> {{ whichTime(data.editTime) }}
                      </time>
                      <el-button type="text" class="read-more">
                        {{ t('boxsPage.viewDetails') }} <i class="el-icon-right"></i>
                      </el-button>
                    </div>
                  </div>
                </div>

                <el-empty
                    v-if="!filteredTabnews[item.name] || filteredTabnews[item.name].length === 0"
                    :description="t('boxsPage.noRelatedBusiness')"
                />
              </el-col>

              <!-- 右侧时间线 -->
              <el-col :xs="24" :md="6" class="timeline-container">
                <h3 class="timeline-title">{{ t('boxsPage.latestRelease') }}</h3>
                <el-timeline>
                  <el-timeline-item
                      v-for="(data, index) in filteredTabnews[item.name]"
                      :key="index"
                      :timestamp="whichTime(data.editTime)"
                      :type="index === 0 ? 'primary' : ''"
                      @click="handleChangepage(data._id)"
                  >
                    <div class="timeline-content">{{ data.title }}</div>
                  </el-timeline-item>
                </el-timeline>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </section>
    </div>

    <!-- 回到顶部按钮 -->
    <el-backtop :visibility-height="100" />
  </div>
</template>

<script setup>
import { Search } from '@element-plus/icons-vue';
import { ref, onMounted, computed, watch } from 'vue';
import moment from 'moment';
import axios from 'axios';
import { useRouter, useRoute } from 'vue-router';
import PageHeader from '@/components/PageHeader.vue';
import { useI18n } from 'vue-i18n';

const { t, locale } = useI18n();

const currentLang = computed(() => locale.value);

moment.locale("zh-cn");
const searchText = ref("");
const visible = ref(false);
const newlist = ref([]);
const loading = ref(true);
const isFallback = ref(false);
const errorMessage = ref("");
const route = useRoute();

const categoriesSection = ref(null);
const whichTab = ref(route.query.tab || '1');

onMounted(() => {
  watch(() => route.query.tab, (newTab) => {
    whichTab.value = newTab || '1';
  });
});

const fallbackBoxes = [
  // 备用数据略
];

onMounted(async () => {
  if (route.query.tab && categoriesSection.value) {
    categoriesSection.value.scrollIntoView({ behavior: 'smooth' });
    setTimeout(() => {
      window.scrollBy({ top: 400, behavior: 'smooth' });
    }, 300);
  }
  try {
    loading.value = true;
    const res = await axios.get('/webapi/boxs/list');
    newlist.value = res.data.data;

    if (res.data.isUsingFallback) {
      isFallback.value = true;
      errorMessage.value = res.data.message || '服务器暂时不可用，显示备用数据';
      if (newlist.value.length === 0) {
        newlist.value = fallbackBoxes;
      }
    }
  } catch (error) {
    console.error('获取业务列表失败:', error);
    isFallback.value = true;
    errorMessage.value = '无法连接到服务器，显示备用数据';
    newlist.value = fallbackBoxes;
  } finally {
    loading.value = false;
  }
});

const searchnewslist = computed(() =>
    searchText.value
        ? newlist.value.filter((item) =>
            item.title.toLowerCase().includes(searchText.value.toLowerCase())
        )
        : []
);

const filteredTopNewsList = computed(() => {
  return newlist.value.filter((item) =>
      item.languages && item.languages.includes(currentLang.value)
  );
});

const filteredTabnews = computed(() => {
  const result = {};
  tablist.forEach((tab) => {
    result[tab.name] = newlist.value.filter(
        (item) =>
            String(item.category) === tab.name &&
            item.languages &&
            item.languages.includes(currentLang.value)
    );
  });
  return result;
});

const getCategoryName = (categoryId) => {
  const map = {
    1: 'boxsPage.categoryTabs.1',
    2: 'boxsPage.categoryTabs.2',
    3: 'boxsPage.categoryTabs.3',
  };
  return t(map[categoryId]) || t('boxsPage.otherBusiness');
};

const tablist = [
  { name: '1', label: 'boxsPage.categoryTabs.1' },
  { name: '2', label: 'boxsPage.categoryTabs.2' },
  { name: '3', label: 'boxsPage.categoryTabs.3' },
];

const router = useRouter();

const handleChangepage = (id) => {
  router.push(`/boxs/${id}`);
};

const whichTime = (time) => {
  return moment(time).format('lll');
};

const getSummary = (content, length = 100) => {
  if (!content) return '暂无简介';
  const plainText = content.replace(/<[^>]+>/g, '');
  return plainText.length <= length ? plainText : plainText.substring(0, length) + '...';
};

// 新增跑马灯暂停状态
const isPaused = ref(false);
function pauseMarquee() {
  isPaused.value = true;
}
function resumeMarquee() {
  isPaused.value = false;
}
</script>



<style lang="scss" scoped>
.boxs-page {
  padding-top: 100px;

  .boxs-banner {
    height: 500px;
    background-size: cover;
    background-position: center;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 60px;

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.1);
    }

    .banner-content {
      position: relative;
      z-index: 2;
      text-align: center;
      color: #fff;
      width: 90%;
      max-width: 800px;

      h2 {
        font-size: 36px;
        font-weight: 700;
        margin-bottom: 15px;
        color: #fff;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
      }

      p {
        font-size: 18px;
        margin-bottom: 30px;
        opacity: 0.9;
      }

      .search-container {
        width: 100%;

        .search-input {
          width: 100%;

          :deep(.el-input__inner) {
            height: 50px;
            border-radius: 25px;
            padding-left: 20px;
            font-size: 16px;
          }
        }
      }
    }
  }

  .search-results {
    max-height: 400px;
    overflow-y: auto;

    .search-item {
      padding: 15px;
      border-bottom: 1px solid #f0f0f0;
      cursor: pointer;
      transition: all 0.3s;

      &:last-child {
        border-bottom: none;
      }

      &:hover {
        background-color: #f5f7fa;

        .item-title {
          color: #409EFF;
        }
      }

      .item-title {
        font-size: 16px;
        font-weight: 500;
        color: #333;
        margin-bottom: 5px;
        transition: color 0.3s;
      }

      .item-meta {
        font-size: 12px;
        color: #909399;
      }
    }
  }

  /* --- 重点改动：跑马灯样式 --- */
  .featured-section {
    margin-bottom: 60px;

    .section-header {
      text-align: center;
      margin-bottom: 20px;
    }

    .marquee-container {
      width: 100%;
      overflow: hidden;
      box-sizing: border-box;
      padding: 10px 0;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.05);
      cursor: grab;
    }

    .marquee-content {
      display: flex;
      width: max-content;
      animation: marqueeScroll 30s linear infinite;
    }

    .featured-card {
      flex: 0 0 280px;
      margin-right: 30px;
      background-color: #fff;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
      cursor: pointer;
      transition: transform 0.3s;

      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
      }

      .card-image {
        height: 160px;
        background-size: cover;
        background-position: center;
        position: relative;

        .card-category {
          position: absolute;
          top: 10px;
          right: 10px;
          background-color: rgba(0, 0, 0, 0.6);
          color: #fff;
          padding: 4px 10px;
          border-radius: 4px;
          font-size: 12px;
        }
      }

      .card-content {
        padding: 15px;

        .card-title {
          font-size: 16px;
          font-weight: 600;
          color: #333;
          margin: 0 0 10px 0;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          line-height: 1.4;
        }

        .card-meta {
          color: #909399;
          font-size: 12px;

          .time {
            display: flex;
            align-items: center;

            i {
              margin-right: 5px;
            }
          }
        }
      }
    }
  }

  @keyframes marqueeScroll {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-50%);
    }
  }

  .categories-section {
    margin-bottom: 60px;

    .category-tabs {
      margin-top: 30px;

      :deep(.el-tabs__header) {
        margin-bottom: 30px;
      }

      :deep(.el-tabs__nav-wrap::after) {
        height: 1px;
      }

      :deep(.el-tabs__active-bar) {
        height: 3px;
      }

      :deep(.el-tabs__item) {
        font-size: 16px;
        font-weight: 500;
        padding: 0 20px 20px;
      }

      :deep(.el-tabs__item.is-active) {
        color: #409EFF;
      }
    }

    .category-list {
      .category-item {
        background-color: #fff;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
        margin-bottom: 20px;
        display: flex;
        cursor: pointer;
        transition: transform 0.3s;

        @media (max-width: 768px) {
          flex-direction: column;
        }

        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);

          .item-title {
            color: #409EFF;
          }
        }

        .item-image {
          flex: 0 0 200px;
          background-size: cover;
          background-position: center;

          @media (max-width: 768px) {
            height: 200px;
            flex: none;
          }
        }

        .item-content {
          flex: 1;
          padding: 20px;

          .item-title {
            font-size: 18px;
            font-weight: 600;
            color: #333;
            margin-top: 0;
            margin-bottom: 10px;
            transition: color 0.3s;
          }

          .item-summary {
            font-size: 14px;
            color: #666;
            line-height: 1.6;
            margin-bottom: 15px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
          }

          .item-meta {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .time {
              font-size: 12px;
              color: #909399;
              display: flex;
              align-items: center;

              i {
                margin-right: 5px;
              }
            }

            .read-more {
              font-size: 14px;
              color: #409EFF;
              display: flex;
              align-items: center;

              i {
                margin-left: 5px;
              }
            }
          }
        }
      }
    }

    .timeline-container {
      .timeline-title {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        margin-top: 0;
        margin-bottom: 20px;
        padding-bottom: 10px;
        border-bottom: 1px solid #eee;
      }

      :deep(.el-timeline-item) {
        cursor: pointer;

        .el-timeline-item__wrapper {
          padding-bottom: 20px;
        }

        .el-timeline-item__timestamp {
          font-size: 12px;
          color: #909399;
        }

        .timeline-content {
          font-size: 14px;
          color: #333;
          transition: color 0.3s;
        }

        &:hover .timeline-content {
          color: #409EFF;
        }
      }
    }
  }
}

.section-header {
  text-align: center;
  margin-bottom: 30px;

  .section-title {
    font-size: 28px;
    font-weight: 700;
    color: #333;
    margin-bottom: 10px;
    position: relative;
    display: inline-block;

    &::after {
      content: '';
      position: absolute;
      bottom: -10px;
      left: 50%;
      transform: translateX(-50%);
      width: 50px;
      height: 3px;
      background-color: #409EFF;
    }
  }

  .section-desc {
    font-size: 16px;
    color: #666;
    max-width: 700px;
    margin: 20px auto 0;
  }
}

.page-container {
  max-width: 1200px;
  padding: 0 15px;
  margin: 0 auto;
}
</style>
